"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPROVE_AMOUNT = exports.ZERO = exports.DEADLINE = exports.NOT_SYNCED = void 0;
const ethers_1 = require("ethers");
exports.NOT_SYNCED = false;
exports.DEADLINE = ethers_1.BigNumber.from(Math.floor(Date.now() / 1000) + 3600 * 24 * 365); //1 year deadline
exports.ZERO = ethers_1.ethers.constants.Zero;
exports.APPROVE_AMOUNT = ethers_1.ethers.constants.MaxUint256;
